import { get, post } from "./api";
import type { AssignMessageRequest, ConversationPage, CrmMessagePage } from "../types/crm";

export const getContactMessages = (
  contactType: string,
  contactId: string,
  pageNumber = 1,
  pageSize = 20
): Promise<CrmMessagePage> =>
  get(
    `/api/crm/messages?contactType=${contactType}&contactId=${contactId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  );

export const getUnmatchedMessages = (
  pageNumber = 1,
  pageSize = 20
): Promise<CrmMessagePage> =>
  get(`/api/crm/messages/unmatched?pageNumber=${pageNumber}&pageSize=${pageSize}`);

export const assignMessage = (
  id: string,
  request: AssignMessageRequest
): Promise<void> => post(`/api/crm/messages/${id}/assign`, request);

export const dismissMessage = (id: string): Promise<void> =>
  post(`/api/crm/messages/${id}/dismiss`);

export const getConversations = (
  pageNumber = 1,
  pageSize = 10,
  unreadOnly = false
): Promise<ConversationPage> =>
  get(`/api/crm/messages/conversations?pageNumber=${pageNumber}&pageSize=${pageSize}&unreadOnly=${unreadOnly}`);

export const markChannelRead = (
  contactType: string,
  contactId: string,
  channel: string
): Promise<void> =>
  post("/api/crm/messages/mark-read", { contactType, contactId, channel });

export interface CreateEntityFromMessageRequest {
  entityType: "Coach" | "Parent" | "ProspectProfile";
  firstName: string;
  lastName?: string;
}

export interface CreateEntityFromMessageResponse {
  entityId: string;
  entityType: "Coach" | "Parent" | "ProspectProfile";
  retroactivelyMatchedCount: number;
}

// Lightweight create-then-claim flow: posts a single endpoint that creates the
// entity, attaches the source message, and re-claims any other unmatched
// messages from the same number/email. The richer create form in
// AssignMessageModal still uses createCrmContact + assignMessage.
export const createEntityFromMessage = (
  messageId: string,
  request: CreateEntityFromMessageRequest
): Promise<CreateEntityFromMessageResponse> =>
  post(`/api/crm/messages/${messageId}/create-entity`, request);
